<ion-row>
  <ion-col size="12">
    <h2 data-cy="image-order-proccessing-header">
      {{ 'i18n.imageOrderingPage.processingMessage' | translate }}
    </h2>

    <p data-cy="image-order-proccessing-body">
      {{ 'i18n.imageOrderingPage.processingDescription' | translate }}
    </p>

    <br />

    <ion-progress-bar
      data-cy="image-order-progress-bar"
      type="indeterminate"
    ></ion-progress-bar>

    <span class="processing-text">{{
      'i18n.imageOrderingPage.processing' | translate
    }}</span>
  </ion-col>
</ion-row>
